import './FAQ.css';
import { enviseer } from '../contents/Content_Enviseer.jsx';
import { envistate } from '../contents/Content_Envistate.jsx';
import { spine } from '../contents/Content_Spine.jsx';
import { envibuddy } from '../contents/Content_Envibuddy.jsx';
import { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useToken } from '../TokenContext.js';

const FAQ = ({currentSession, updateQuery, updateQueryResponse, username}) => {

  // const faqs = [
  //   { question: "How to apply for leave?", icon: "bi bi-calendar-check" },
  //   { question: "What are the health benefits?", icon: "bi bi-heart-pulse" },
  //   { question: "How to update my personal information?", icon: "bi bi-person-lines-fill" },
  //   { question: "What is the policy for working from home?", icon: "bi bi-house-door" },
  // ];
const [fAQ, setFAQ]= useState([]);
  useEffect(() => {
    fetch('https://infia.enviseer.com/api/llm_backend/frequent_asked?company=Enviseer', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        const filteredFAQs = data.slice(1).map((item) => ({
          ...item,
          question: item.question
            .replace(/^\d+\.\s*/, '')   // Removes leading number and dot
            .replace(/^'(.*)'$/, '$1'), // Removes single quotes from the beginning and end
        }));
        setFAQ(filteredFAQs);
      })
      .catch((error) => console.error('Error fetching user count:', error));
  }, []);
  const companyName = useToken().companyName;

  const faqs= companyName==='spine'? spine.faqs:companyName==='envistate'? envistate.faqs:companyName==='enviseer'?enviseer.faqs:envibuddy.faqs;
  FAQ.propTypes = {
  username: PropTypes.string.isRequired,
  };

  const token=useToken().token;
 //console.log("fAQ", fAQ);
  const handleFaqClick = (faqQuestion) => {
    updateQuery(faqQuestion);

    const apiUrl = `https://infia.enviseer.com/api/llm/query`;
    const queryData = {
      query: faqQuestion,
      session_id: currentSession,
      company: companyName,
      doc_type: "HR",
      query_type: "query",
      email:username,
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(queryData),
    })
      .then((response) => {
    if (response.status === 401) {
      // Redirect to the login page if unauthorized
      window.location.href = 'https://infia.enviseer.com/';
      return; // Stop further processing
    }
    return response.json(); // Parse the JSON response if the status is not 401
  })
      .then((data) => {
        //console.log('Response from server:', data.response);
        updateQueryResponse(data.response);
      })
      .catch((error) => {
        console.error('Error during fetch:', error);
      });
  };
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userSettings, setUserSettings] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    customerId: '',
  });
  if (loading && !error) {
    ""
  }

  // const handleLogout = () => {
  //   document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //   document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //   window.location.href = 'https://infia.enviseer.com/';
  // };

  useEffect(() => {
    fetchUserSettings();
  }, []);

  const fetchUserSettings = useCallback(async () => {
    setLoading(true);
    setError(null);

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const token = getCookie('token');
    const username = getCookie('username');

    if (!token || !username) {
      setUserSettings({
        username: "Guest",
        email: "",
        firstName: "Guest",
        lastName: "User",
        profileImg: null,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`https://infia.enviseer.com/api/api/user/fetchUser?email=${username}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'X-Application-Name': 'envi-onboarding'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          // handleLogout(); // Uncomment if you want to handle logout on 401
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }

      const data = await response.json();
      setUserSettings({
        username: data.displayName || "Guest",
        email: data.email || "",
        firstName: data.firstName || "Guest",
        lastName: data.lastName || "",
        profileImg: data.profileImg || null,
      });
    } catch (error) {
      console.error("Error fetching user settings:", error);
      setError(error.message);
      setUserSettings({
        username: "Guest",
        email: "",
        firstName: "Guest",
        lastName: "",
        profileImg: null,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
    {!useToken().isGuestToken?
    <div className="faq-section">
      <h2 className="faq-title">Hi {userSettings.firstName}! How can I assist you today?</h2>
      <div className="faq-items">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item" onClick={() => handleFaqClick(faq.question)}>
            <i className={faq.icon}></i>
            <span>{faq.question}</span>
          </div>
        ))}
      </div>
    </div>:
    <div style={{width:"100%"}}>
      <div style={{backgroundColor:"#eeeef5", padding:"8px", borderRadius:'8px', width:"250px"}}>
        <div>Hi There,</div>
        <div>How can i help you today? </div> 
      </div>
      <div className="guest-faq-container">
  {faqs.map((faq, index) => (
    <div 
      key={index} 
      className="guest-faq-item" 
      onClick={() => handleFaqClick(faq.question)}
    >
      <i className={faq.icon}></i>
      <span>{faq.question}</span>
    </div>
  ))}
</div>


</div>
      }
    </>
  );
};

FAQ.propTypes = {
  currentSession: PropTypes.object.isRequired,
  updateQuery: PropTypes.func.isRequired,
  updateQueryResponse: PropTypes.func.isRequired,
};

export default FAQ;
